import ApplicationAdapter from 'lumen/adapters/application';

export default class SeenUserEngagementElementAdapter extends ApplicationAdapter {
  // @ts-expect-error: Property 'buildURL' in type 'SeenUserEngagementElementAdapter' is not assignable to the same property in base type 'ApplicationAdapter'.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  buildURL(
    modelName: string,
    id: string,
    snapshot: unknown,
    requestType: string,
    query: Record<string, unknown>,
  ) {
    if (requestType === 'createRecord') {
      return `${this.host}/${this.namespace}/user_engagements_elements/`;
    }

    // @ts-expect-error: Expected 3 arguments, but got 5.
    return super.buildURL(modelName, id, snapshot, requestType, query);
  }
}
